import React from 'react';

import { MovePlannerHostProvider } from '@hopdrive/feature-move-planner';

import { useEmbedPlannerHost } from './useEmbedPlannerHost';

/** Mounts the Move Planner's host for the Embed. */
export function EmbedPlannerHost({ children }: { children?: React.ReactNode }) {
  const host = useEmbedPlannerHost();
  return <MovePlannerHostProvider value={host}>{children}</MovePlannerHostProvider>;
}
